import type { JSX } from 'react';
import { getOrElse } from 'dg-web-shared/lib/MaybeV2.ts';
import { LabeledText } from '../../ui/labeled-elements/LabeledText.tsx';
import { FrontendTariffDefinition } from 'taxomex-shared/tariff/models/TariffDefinition.ts';
import { Localized } from 'dg-web-shared/lib/Localization.tsx';

export interface TariffPreviewProps {
    tariff?: {
        name: string;
        tariffDefinition: FrontendTariffDefinition;
    } | null;
    showName?: boolean;
    language: string;
}

export function TariffPreview(props: TariffPreviewProps): JSX.Element | null {
    if (props.tariff) {
        return (
            <div>
                {getOrElse(props.showName, true) && (
                    <LabeledText
                        label={
                            <Localized
                                de="Tarifname"
                                fr="Nom tarif"
                                it="Nome tariffa"
                                en="Tariff name"
                            />
                        }
                    >
                        {props.tariff.name}
                    </LabeledText>
                )}
            </div>
        );
    } else {
        return null;
    }
}
